export const config_type = [
    {
        label:'设置温度',
        value:1
    },
    {
        label:'开关机',
        value:2
    },
    {
        label:'模式设定',
        value:3
    },{
        label:'风速设定',
        value:5
    },
    {
        label:'水阀状态',
        value:6
    },
    {
        label:'锁定状态',
        value:34
    }
]